import { render } from "./ContatoPessoaModal.vue?vue&type=template&id=8b4b172a&scoped=true&ts=true"
import script from "./ContatoPessoaModal.vue?vue&type=script&lang=ts"
export * from "./ContatoPessoaModal.vue?vue&type=script&lang=ts"

import "./ContatoPessoaModal.vue?vue&type=style&index=0&id=8b4b172a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4b172a"]])

export default __exports__